import React, { useState } from "react";
import {
  Layout as AntLayout,
  Menu,
  Form,
  Typography,
  Button,
  notification,
  Row,
  Col,
  Input,
} from "antd";
import Siderbar from "./SideBar";
import { Link } from "react-router-dom";
import Modal from "antd/lib/modal/Modal";
import auth from "Api/auth";

const { Header, Content, Footer, Sider } = AntLayout;

const Layout: React.SFC = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const {
    mutate,
    result: { isLoading },
  } = auth.useChangePassword();
  const [form] = Form.useForm();
  return (
    <AntLayout style={{ minHeight: "100vh" }}>
      <Header
        className="header"
        title="مدیریت انبار بخش شیمی دانشگاه شیراز"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Typography.Title level={4} style={{ flex: 1, color: "white" }}>
          سامانه مدیریت انبار بخش شیمی دانشگاه شیراز
        </Typography.Title>
        <Menu theme="dark" mode="horizontal" selectedKeys={["3"]} dir="">
          <Menu.Item key="1" onClick={() => setShowModal(!showModal)}>
            تغییر رمز عبور
          </Menu.Item>
          <Menu.Item key="2">
            <Link to="/logout">خروج</Link>
          </Menu.Item>
        </Menu>
      </Header>
      <Content style={{ padding: "0 50px" }}>
        <AntLayout
          className="site-layout-background"
          style={{ padding: "24px 0" }}
        >
          <Sider className="site-layout-background" width={250}>
            <Siderbar />
          </Sider>
          <Content style={{ padding: "0 24px", minHeight: 280 }}>
            {children}
          </Content>
        </AntLayout>
      </Content>
      <Footer style={{ textAlign: "center" }}>
        تمامی حقوق محفوظ است - بخش شیمی دانشگاه شیراز
      </Footer>
      <Modal
        visible={showModal}
        title="ثبت درخواست"
        onOk={() => {}}
        onCancel={() => setShowModal(false)}
        footer={[
          <Button onClick={() => setShowModal(false)}>انصراف</Button>,
          <Button
            type="primary"
            disabled={isLoading}
            loading={isLoading}
            onClick={form.submit}
          >
            ثبت درخواست
          </Button>,
        ]}
      >
        <Form
          initialValues={{ password: "" }}
          form={form}
          onFinish={(values) => {
            mutate(
              {
                type: "post",
                body: { password: values.password },
                onSuccess() {
                  setShowModal(false);
                  notification.open({
                    message: "رمز عبور با موفقیت تغییر یافت",
                  });
                },
              },
              {
                onSuccess: () =>
                  notification.success({
                    message: "رمز عبور با موفقیت تغییر کرد",
                  }),
                onError: () =>
                  notification.error({
                    message: "خطا در تغییر رمز عبور",
                  }),
              }
            );
          }}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                hasFeedback
                rules={[
                  { required: true },
                  ({ validateFields }) => ({
                    validator() {
                      validateFields(["c_password"]);
                      return Promise.resolve();
                    },
                  }),
                ]}
                label="رمز عبور"
                name="password"
              >
                <Input type="password" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                hasFeedback
                rules={[
                  { required: true },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject("تکرار رمز با رمز عبور برابر نیست");
                    },
                  }),
                ]}
                label="تکرار رمز عبور"
                name="c_password"
              >
                <Input type="password" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </AntLayout>
  );
};

export default Layout;
